// extracted by mini-css-extract-plugin
module.exports = {"ant-btn":"like-button_ant-btn__boETC","action-btn":"like-button_action-btn__pmeOQ","active":"like-button_active___ck7R","hover":"like-button_hover__HKQPG"};